// commentForm.js
import React, { useRef, useMemo, useCallback } from "react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import TextBox from "devextreme-react/text-box";
import useFetch from "../../../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { isMobile } from "../../../../Utils/media-query";
import { handlePostComments } from "../../../../Utils/handlePOST/handlePostComment";
import { getUserId } from "../../../../Utils/helper";

export default function CommentForm({ orderId, setNotifications, onClose }) {
  const navigate = useNavigate(),
    fetch = useFetch(navigate);

  const message = useRef("");
  const onValueChanged = (e) => {
    message.current = e.value;
  };
  const userId = getUserId();
  const submitComment = useCallback(async () => {
    const comment = message.current.trim();

    if (!comment) {
      setNotifications({
        success: false,
        messege: "Please enter a comment.",
      });
      return;
    }
    const { response, isDataGood } = await handlePostComments(
      orderId,
      message.current,
      userId,
      new Date().toISOString(),
      fetch,
    );
    setNotifications(response);
    if (isDataGood) {
      onClose();
    }
  }, [orderId, userId, fetch, onClose, setNotifications]);

  const submitOptions = useMemo(() => {
    return {
      stylingMode: "contained",
      text: "Send",
      onClick: () => {
        submitComment();
      },
    };
  }, [submitComment]);

  const cancelOptions = useMemo(() => {
    return {
      stylingMode: "outlined",
      text: "cancel",
      onClick: () => onClose(),
    };
  }, [onClose]);

  return (
    <Popup
      visible={true}
      onHiding={() => onClose()}
      hideOnOutsideClick={true}
      title="New Comment"
      width={isMobile ? "100%" : "50%"}
      height="auto"
      resizeEnabled={true}
    >
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={cancelOptions}
      />
      <TextBox
        spellcheck={true}
        placeholder="Type comment..."
        onValueChanged={onValueChanged}
        valueChangeEvent="input"
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={submitOptions}
      />
    </Popup>
  );
}
